import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { API_URL } from '../constants'
import { paramsSerializer } from '../utils/serialize-array'
import { AllowlistHeader } from '@/types/organizations'

const getAllowlistHeader = async () => {
  const url = `${API_URL}/organizations/allowlist-header/`
  const { data } = await axios.get(url, { withCredentials: true, paramsSerializer: paramsSerializer })

  return data
}

const useAllowlistHeader = () => {
  return useQuery<AllowlistHeader>({
    queryKey: ['allowlist_header'],
    queryFn: () => getAllowlistHeader(),
  })
}

export { useAllowlistHeader }
